import { useDispatch } from "react-redux";
import {
  openPhraseForm,
  setFrasesFilters,
} from "../../store/reducers/plantels/phrasesByPlantel.reducer";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";

const FrasesFilters = ({ plantelId }) => {
  const dispatch = useDispatch();
  const talentos = useSelector((state) => state.talentsSelector?.list || []);

  const { filters } = useSelector((state) => state.frasesByPlantel);
  // console.log(filters);
  return (
    <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
      {/* RANDOM toggle */}
      <button
        type="button"
        className={`btn btn-sm d-inline-flex align-items-center gap-2 px-3 ${
          filters.isRandom ? "btn-success shadow-sm" : "btn-outline-secondary"
        }`}
        onClick={() =>
          dispatch(
            setFrasesFilters({
              isRandom: !filters.isRandom,
              talentoPlantelId: null, // limpia talento si se activa random
            }),
          )
        }
      >
        <Icon
          icon={
            filters.isRandom ? "mdi:shuffle-variant" : "mdi:shuffle-disabled"
          }
          width="16"
        />
        {filters.isRandom ? "Frases aleatorias" : "Frases aleatorias"}
      </button>

      {/* Select talento */}
      <div className="position-relative" style={{ minWidth: "220px" }}>
        <Icon
          icon="mdi:account-group-outline"
          width="16"
          className="position-absolute top-50 start-0 translate-middle-y ms-2 text-muted"
          style={{ pointerEvents: "none", zIndex: 2 }}
        />

        <select
          className="form-select form-select-sm"
          style={{ paddingLeft: "2rem" }}
          value={filters.talentoPlantelId || ""}
          onChange={(e) =>
            dispatch(
              setFrasesFilters({
                talentoPlantelId: e.target.value || null,
              }),
            )
          }
        >
          <option value="">Todos los talentos</option>
          {talentos.map((t) => (
            <option key={t.id} value={t.id}>
              {t.label}
            </option>
          ))}
        </select>
      </div>
      <button
        type="button"
        className="btn btn-primary btn-sm d-flex align-items-center gap-2 px-3 shadow-sm"
        onClick={() => dispatch(openPhraseForm())}
      >
        <Icon icon="mdi:plus" width="16" />
        Nueva frase
      </button>
    </div>
  );
};

export default FrasesFilters;
